angular.module('impactx.panel').controller('SelectReferencePanelCtrl', SelectReferencePanelCtrl);

SelectReferencePanelCtrl.$inject = ['productComparison', 'AddToBasketService', 'FavoritesService', 'ProductViewService',
    'TranslationService', '$redirect', '$context', 'ThemeWorldService', 'panelService', 'dataGen', '$timeout', '$scope'];

function SelectReferencePanelCtrl(productComparison, AddToBasketService, FavoritesService, ProductViewService,
                                  TranslationService, $redirect, $context, ThemeWorldService, panelService, dataGen,
                                  $timeout, $scope) {
    var self = this;

    self.trns = {
        required: TranslationService.get('required'),
        productNotAvailable: TranslationService.get('productNotAvailable')
    };

    var variantNameCache = undefined;
    var notCombinedVariantNameCache = {};
    var combinedVariantValuesCache = {};
    var variantCacheNeedsReset = {};
    var minPrice = undefined;
    var minPriceIsStartPrice = false;
    var currentShownProductId = 0;
    self.minPriceString = "";
    self.useMainAdditionalPrice = false;
    self.mainAdditionalPrice = {};
    var roundingFactor = Math.pow(10, 16);

    self.getProductPanelColor = panelService.getProductPanelColor;

    self.selectProduct = function () {
        self.product.isSelected = !self.product.isSelected;
        if (self.selectedProducts) {
            if (self.product.isSelected) {
                self.selectedProducts.push(self.product);
            }
            else {
                var index = self.selectedProducts.indexOf(self.product);
                if (index >= 0) {
                    self.selectedProducts.splice(index, 1)
                }
            }
        }
    };

    self.options = [];

    var toDetails = {
        label: TranslationService.get("details")
    };
    toDetails.func = function () {
        var patIds = [];
        for (var variant in self.product.selectedVariants) {
            if (self.product.selectedVariants.hasOwnProperty(variant)) {
                patIds.push(self.getVariantPatId(variant));
            }
        }
        if (patIds.length > 0) {
            $redirect.redirectTo(null, "/product/" + self.product.id + "/false/0/" + patIds);
        }
        else {
            $redirect.redirectTo(null, "/product/" + self.product.id);
        }
        self.detailsFunction();
    };


    self.$onInit = function () {
        self.init();
    };

    this.getVariantListValue = function (variantList, variantName) {
        var variantListValue = null;
        for (var i = 0; i < variantList.length; i++) {
            if (variantList[i].patName === variantName) {
                variantListValue = variantList[i].plainText;
                break;
            }
        }
        return variantListValue;
    };

    this.getVariantPatId = function (variantName) {
        var variantList = self.product.variants[0].variantList;
        var patId = null;
        for (var i = 0; i < variantList.length; i++) {
            if (variantList[i].patName === variantName) {
                patId = variantList[i].patId;
                break;
            }
        }
        return patId;
    };

    self.init = function () {
        self.options.length = 0;
        self.options.push(toDetails);
        currentShownProductId = self.product.id;
        if (self.product.selectedProductVariant) {
            self.product.selectedVariants = {};
            for (var i = 0; i < self.product.selectedProductVariant.variantList.length; i++) {
                var variant = self.product.selectedProductVariant.variantList[i];
                self.product.selectedVariants[variant.patName] = {
                    id: self.product.selectedProductVariant.id,
                    variantValue: variant.plainText
                };
            }
        }
        self.updatePrice();
    };

    this.collectVariantNames = function () {
        if (variantNameCache === undefined) {
            var properties = [];
            for (var i = 0; i < self.product.variants[0].variantList.length; i++) {
                properties.push(self.product.variants[0].variantList[i].patName);
            }
            variantNameCache = properties;
        }
        return variantNameCache;
    };

    this.getCombinedValuesForVariantName = function (variantName) {
        if (combinedVariantValuesCache[variantName] === undefined) {
            var variantValues = [];
            for (var i = 0; i < self.product.variants.length; i++) {
                var value = self.getVariantListValue(self.product.variants[i].variantList, variantName);
                var alreadySet = false;
                for (var j = 0; j < variantValues.length; j++) {
                    if (variantValues[j].variantValue === value) {
                        alreadySet = true;
                        break;
                    }
                }
                if (!alreadySet) {
                    if (self.checkIfCombined(self.product.variants[i].variantList, variantName)) {
                        variantValues.push({id: self.product.variants[i].id, variantValue: value})
                    }
                }
            }
            combinedVariantValuesCache[variantName] = variantValues;
        }

        return combinedVariantValuesCache[variantName];
    };

    this.checkIfCombined = function (variantList, variantName) {
        var mismatch = false;
        for (var prop in self.product.selectedVariants) {
            if (variantName !== prop) {
                if (self.product.selectedVariants.hasOwnProperty(prop) && self.product.selectedVariants[prop] && self.product.selectedVariants[prop].variantValue !== undefined) {
                    mismatch = self.product.selectedVariants[prop].variantValue !== self.getVariantListValue(variantList, prop);
                    if (mismatch) {
                        break;
                    }
                }
            }
        }
        return !mismatch;
    };

    this.checkIfMatchesSelection = function (variantList) {
        var mismatch = false;
        for (var prop in self.product.selectedVariants) {
            if (self.product.selectedVariants.hasOwnProperty(prop) && self.product.selectedVariants[prop] && self.product.selectedVariants[prop].variantValue !== undefined) {
                mismatch = self.product.selectedVariants[prop].variantValue !== self.getVariantListValue(variantList, prop);
                if (mismatch) {
                    break;
                }
            }
        }
        return !mismatch;
    };

    this.getNotCombinedValuesForVariantName = function (variantName) {
        if (notCombinedVariantNameCache[variantName] === undefined) {
            var variantValues = [];
            for (var i = 0; i < self.product.variants.length; i++) {
                var value = self.getVariantListValue(self.product.variants[i].variantList, variantName);
                var alreadySet = false;
                for (var j = 0; j < variantValues.length; j++) {
                    if (variantValues[j].variantValue === value) {
                        alreadySet = true;
                        break;
                    }
                }
                var combinedVariantValues = self.getCombinedValuesForVariantName(variantName);
                for (var k = 0; k < combinedVariantValues.length; k++) {
                    if (combinedVariantValues[k].variantValue === value) {
                        alreadySet = true;
                        break;
                    }
                }
                if (!alreadySet) {
                    if (!self.checkIfCombined(self.product.variants[i].variantList, variantName)) {
                        variantValues.push({id: self.product.variants[i].id, variantValue: value, notCombined: true})
                    }
                }
            }
            notCombinedVariantNameCache[variantName] = variantValues;
        }

        return notCombinedVariantNameCache[variantName];
    };

    this.selectVariant = function (variantName, variantValue) {
        var wasSelected = self.product.isSelected;
        if (!wasSelected) {
            self.product.isSelected = true;
            if (self.selectedProducts) {
                self.selectedProducts.push(self.product);
            }
        }
        $timeout(function () {
            if (variantValue) {
                if (variantValue.notCombined) {
                    var variantList = {};
                    for (var i = 0; i < self.product.variants.length; i++) {
                        if (self.product.variants[i].id === variantValue.id) {
                            variantList = self.product.variants[i].variantList;
                            break;
                        }
                    }

                    for (var variant in self.product.selectedVariants) {
                        if (self.product.selectedVariants.hasOwnProperty(variant)) {
                            if (self.product.selectedVariants[variant].variantValue !== self.getVariantListValue(variantList, variant)) {
                                self.product.selectedVariants[variant] = {};
                            }
                        }
                    }
                }
            }

            var totalNumberOfVariantNames = self.collectVariantNames().length;
            var numberOfSelectedVariantNames = 0;
            for (var variant in self.product.selectedVariants) {
                if (self.product.selectedVariants.hasOwnProperty(variant) && self.product.selectedVariants[variant] &&
                    self.product.selectedVariants[variant].id && self.product.selectedVariants[variant].id > 0) {
                    numberOfSelectedVariantNames++;
                }
            }

            notCombinedVariantNameCache = {};
            combinedVariantValuesCache = {};

            $timeout(function () {
                self.updatePrice();
            });
        });
    };

    this.updatePrice = function () {
        minPrice = undefined;
        self.minPriceString = "";
        if (self.product.variants) {
            self.collectVariantNames();
            for (var j = 0; j < variantNameCache.length; j++) {
                self.getCombinedValuesForVariantName(variantNameCache[j]);
            }
            var actualProductId;
            var uniquePrices = [];
            for (var i = 0; i < self.product.variants.length; i++) {
                if (self.checkIfMatchesSelection(self.product.variants[i].variantList)) {
                    self.useMainAdditionalPrice = !self.product.variants[i].basketLink.price.basePrice;
                    var price = !self.useMainAdditionalPrice ? self.product.variants[i].basketLink.price : self.product.variants[i].basketLink.mainAdditionalPrice;
                    if (price && price.basePriceValue !== null) {
                        var roundedPrice = Math.round(price.basePriceValue * roundingFactor);
                        if (uniquePrices.indexOf(roundedPrice) < 0) {
                            uniquePrices.push(roundedPrice);
                        }
                        if (minPrice === undefined || price.basePriceValue < minPrice) {
                            actualProductId = self.product.variants[i].id;
                            minPrice = price.basePriceValue;
                            minPriceIsStartPrice = price.startPrice;
                            self.minPriceString = price.basePrice;
                            if (self.useMainAdditionalPrice) {
                                self.mainAdditionalPrice = price;
                            }
                        }
                    }

                }
            }
            if (!actualProductId && self.product.variants.length > 0) {
                actualProductId = self.product.variants[0].id;
            }
            if (!minPriceIsStartPrice) {
                if (uniquePrices.length > 1) {
                    self.minPriceString = $scope.trns.startPricePrefix + " " + self.minPriceString;
                }
            }
            if (self.product.selectedVariants) {
                if (actualProductId !== currentShownProductId) {
                    currentShownProductId = actualProductId;
                    self.product.id = currentShownProductId;
                    if (currentShownProductId > 0) {
                        return dataGen.getData({}, {
                            id: currentShownProductId,
                            oldBKIId: 0,
                            fullyConfigured: true
                        }, "/product/view").then(function (data) {
                            //check if product id may have changed since start of request. Normally not the case, just to make sure.
                            if (actualProductId === currentShownProductId) {
                                self.product.imageUrl = data.data.imageUrl;
                                self.product.name = data.data.name;
                                self.product.manufacturer = data.data.manufacturer;
                            }
                        });
                    }
                }
            }
        }
    }
}